import { defineStore } from 'pinia'
import { getGoalTranslationLanguages } from './translation/api'
import type { TranslationLanguage } from './translation/translation_types'

/** The languages a goal can be translated into, and which access point pages have their translation open, in which language. */
export const useGoalTranslationStore = defineStore('goalTranslation', {
  state: () => ({
    languages: [] as TranslationLanguage[],
    activeContentUuids: [] as string[],
    requestedLanguageByContentUuid: {} as Record<string, string>
  }),

  getters: {
    isTranslationActiveFor(state) {
      return (contentUuid: string): boolean => state.activeContentUuids.includes(contentUuid)
    },
    requestedLanguageFor(state) {
      return (contentUuid: string): string => state.requestedLanguageByContentUuid[contentUuid] ?? ''
    }
  },

  actions: {
    async fetchLanguages() {
      this.languages = await getGoalTranslationLanguages()
    },

    requestTranslationFor(contentUuid: string, language: string) {
      this.requestedLanguageByContentUuid[contentUuid] = language
      this.activateTranslationFor(contentUuid)
    },

    activateTranslationFor(contentUuid: string) {
      if (!this.activeContentUuids.includes(contentUuid)) {
        this.activeContentUuids.push(contentUuid)
      }
    },

    deactivateTranslationFor(contentUuid: string) {
      this.activeContentUuids = this.activeContentUuids.filter((uuid) => uuid !== contentUuid)
    },

    deactivateAllTranslations() {
      this.activeContentUuids = []
      this.requestedLanguageByContentUuid = {}
    }
  }
})
